import { ObjectTypes } from "../enums/object-types";

export class Redlining {
  id: number;
  regionID: number;
  userID: number;
  deviceID: string;
  parentObjectID: number;
  subParentID: number;
  objectID: number;
  objectType: string;
  referencepage: Reference;
  subject: string;
  content: string;
  attachmentExist: boolean;
  attachmentsCount: number;
  createdDate: string;
  lastChanged: string;
  isSaved: boolean;
  newLocationGeometries: string;
  priorityLevel: Priority;
  priority:string;//local property for showing value
  user:string;//local property for showing value
  priorityText: string;
  hasAddedToWorkOrder:boolean;
  workOrderNumber:number;
  status:string;
  cSObjectId:string;
}
//  export enum ObjectTypes {
//   Building,
//   Trench,
//   Duct,
//   Cable,
//   Floor,
//   Room,
//   Rack,
//   Component,
//   ComponentPort,
//   PLP,
//   FWS,
//   Service,
// }
export enum Reference {
  Home,
  BuildingInfra,
  RackView,
  DuctView,
  SchemaPlan,
}
export enum Priority {
  // None,
  // Low,
  // Medium,
  // High
  Keine,
  Niedrig,
  Mittel,
  Hoch
}
